import education       from '../pages/education/Education.vue'


export default [
    {
        path: '/education',
        name: 'education',
        component: education,
    }
]
